/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import {
    ArrowRight,
    BarChart3,
    Briefcase,
    Landmark,
    BrainCircuit
} from "lucide-react";

export default function CTASection() {

    const actions = [

        {
            icon: BarChart3,
            title: "Explore Markets",
            href: "/stock"
        },

        {
            icon: Briefcase,
            title: "Portfolio Analytics",
            href: "/portfolio"
        },

        {
            icon: Landmark,
            title: "Mutual Funds",
            href: "/mf"
        },

        {
            icon: BrainCircuit,
            title: "AI Research",
            href: "/research"
        }
    ];

    return (

        <section className="mb-12">

            <div className="
                relative
                overflow-hidden
                rounded-[36px]
                bg-gradient-to-br
                from-slate-950
                via-blue-950
                to-slate-950
                px-8
                py-20
                shadow-2xl
            ">

                {/* Background Effects */}

                <div className="
                    absolute
                    top-0
                    left-0
                    w-96
                    h-96
                    bg-blue-500/20
                    blur-3xl
                    rounded-full
                "/>

                <div className="
                    absolute
                    bottom-0
                    right-0
                    w-96
                    h-96
                    bg-emerald-500/20
                    blur-3xl
                    rounded-full
                "/>

                <div className="
                    absolute
                    inset-0
                    bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.06)_1px,transparent_1px)]
                    bg-[size:24px_24px]
                    opacity-30
                "/>

                <div className="relative z-10">

                    {/* Heading */}

                    <div className="text-center max-w-4xl mx-auto">

                        <div className="
                            inline-flex
                            items-center
                            gap-2
                            px-4
                            py-2
                            rounded-full
                            bg-white/10
                            border
                            border-white/10
                            text-slate-300
                            text-sm
                            mb-6
                        ">

                            Investment Intelligence Platform

                        </div>

                        <h2 className="
                            text-5xl
                            md:text-6xl
                            font-bold
                            text-white
                            leading-tight
                            mb-6
                        ">

                            Smarter Investing
                            <br/>

                            Starts Here

                        </h2>

                        <p className="
                            text-xl
                            text-slate-300
                            leading-relaxed
                            max-w-3xl
                            mx-auto
                            mb-12
                        ">

                            Real-time market analytics,
                            portfolio intelligence,
                            mutual fund research and
                            AI-powered insights —
                            all in one platform.

                        </p>

                    </div>

                    {/* Primary CTA */}

                    <div className="
                        flex
                        justify-center
                        mb-14
                    ">

                        <a
                            href="/stock"
                            className="
                                inline-flex
                                items-center
                                gap-3
                                px-8
                                py-4
                                rounded-2xl
                                bg-blue-600
                                text-white
                                font-semibold
                                text-lg
                                hover:bg-blue-500
                                transition-all
                                shadow-lg
                            "
                        >

                            Launch Analytics

                            <ArrowRight size={20} />

                        </a>

                    </div>

                    {/* Quick Navigation */}

                    <div className="
                        grid
                        md:grid-cols-2
                        lg:grid-cols-4
                        gap-6
                    ">

                        {actions.map((item, idx) => {

                            const Icon = item.icon;

                            return (

                                <a
                                    key={idx}
                                    href={item.href}
                                    className="
                                        group
                                        bg-white/5
                                        border
                                        border-white/10
                                        rounded-3xl
                                        p-6
                                        hover:bg-white/10
                                        transition-all
                                        duration-300
                                    "
                                >

                                    <Icon
                                        size={30}
                                        className="
                                            text-blue-400
                                            mb-4
                                        "
                                    />

                                    <div className="
                                        text-white
                                        font-semibold
                                        text-lg
                                        mb-2
                                    ">
                                        {item.title}
                                    </div>

                                    <div className="
                                        flex
                                        items-center
                                        gap-2
                                        text-slate-400
                                        group-hover:text-slate-200
                                    ">

                                        Open Module

                                        <ArrowRight size={16} />

                                    </div>

                                </a>

                            );
                        })}

                    </div>

                </div>

            </div>

        </section>

    );
}